import { withLayout } from '../../Layout/Layout';
import { httpGet } from '../../utils/httpClient';
import { AuthorProfile } from '../../components/Author/Author';
import Head from 'next/head';
import React from 'react';

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};
export const getStaticProps = async ({ params }) => {
  const articleRes = await httpGet(
    `${process.env.javaApiUrl}/author/${params.id}`
  );
  const contents = await Promise.all([
    await httpGet(
      `${process.env.javaApiUrl}/author/${params.id.toLowerCase()}/articles`
    ).then((r) => r.json()),
    await httpGet(
      `${process.env.javaApiUrl}/author/${params.id.toLowerCase()}/airline`
    ).then((r) => r.json()),
    await httpGet(
      `${process.env.javaApiUrl}/author/${params.id.toLowerCase()}/hotel`
    ).then((r) => r.json()),
  ]);
  if (articleRes.status >= 400) {
    return {
      notFound: true,
      revalidate: 60,
    };
  }
  const author = await articleRes.json();
  if (author.textId && author.textId !== params.id) {
    return {
      redirect: {
        destination: `/airlines/articles/${author.textId}`,
        permanent: false,
        // statusCode: 301
      },
    };
  }

  return {
    props: {
      author,
      articles: contents[0],
      airlineReviews: contents[1],
      hotelReviews: contents[2],
    },
    revalidate: 60,
  };
};

function AuthorPage({ author, articles, airlineReviews, hotelReviews }) {
  return (
    <>
      <Head>
        <title>
          Author {author.user.firstName} {author.user.lastName} page -
          First-Class.com
        </title>
      </Head>
      <AuthorProfile
        author={author}
        articles={articles}
        airlineReviews={airlineReviews}
        hotelReviews={hotelReviews}
      />
    </>
  );
}

export default withLayout(AuthorPage, true);
